module.exports = __webpack_public_path__ + "img/pingaksh_logo_white.4dcb029d.svg";